<div class="breadcrumb-container">
  <div class="breadcrumb container-xl pt-0 pb-0 mt-0 mb-0">
    <div [@fadeInOut] *ngIf="leftFadeVisible$ | async" class="scroll-fade left"></div>
    <div [@fadeInOut] *ngIf="rightFadeVisible$ | async" class="scroll-fade right"></div>
    <ul #scrollContainer class="scroll-container" aria-label="breadcrumb">
      <li
        *ngFor="let link of breadCrumbs; let i = index; let isLast = last"
        id="breadcrumb_{{ link.title.replace(' ', '_').toLowerCase() }}"
        tabindex="-1"
        class="breadcrumb__item"
        [attr.aria-current]="isLast ? 'page' : null"
        [ngClass]="{ 'breadcrumb__item--modern': componentData?.layout === 'modern' }"
        (click)="navigateToUrl(link, isLast)"
        (accessibleClick)="navigateToUrl(link, isLast)"
      >
        <div
          class="breadcrumb__item-content typography-small-text mat-caption"
          [ngClass]="{ 'breadcrumb__item-content--modern': componentData?.layout === 'modern' }"
        >
          <span [attr.tabindex]="isLast ? '' : '0'">
            {{ link.customVariableTitle || breadcrumbService.breadcrumbTranslations[link.title] | translate }}
          </span>
        </div>
      </li>
    </ul>
  </div>
</div>
